var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00022 5.0001C5.00012 4.6482 5.09287 4.30249 5.26911 3.99789C5.44534 3.6933 5.69883 3.44059 6.00397 3.2653C6.30911 3.09001 6.6551 2.99833 7.00701 2.99952C7.35892 3.00072 7.70428 3.09474 8.00822 3.2721L20.0052 10.2701C20.308 10.4458 20.5593 10.6978 20.7342 11.0011C20.909 11.3044 21.0012 11.6482 21.0015 11.9982C21.0018 12.3483 20.9102 12.6923 20.7359 12.9958C20.5616 13.2994 20.3107 13.5519 20.0082 13.7281L8.00822 20.7281C7.70428 20.9055 7.35892 20.9995 7.00701 21.0007C6.6551 21.0019 6.30911 20.9102 6.00397 20.7349C5.69883 20.5596 5.44534 20.3069 5.26911 20.0023C5.09287 19.6977 5.00012 19.352 5.00022 19.0001V5.0001Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.20634b32e3d4011ffe7e789decad91d0.svg";
export { ForwardRef as ReactComponent };